export const isAuthenticated = (state) => {
   
    const hasValidToken = !!state?.auth?.auth?.access_token;
    const isOtpVerified = state?.auth?.auth?.isOtpVerified;
    const requiresOtp = state?.auth?.auth?.requiresOtpVerification;
    
    
    if (!requiresOtp) return hasValidToken;
    
 
    return hasValidToken && isOtpVerified;
};
